const zipFunction = () => {
    $(document).ready(() => {
        const zipForm = $('.zip-button');

        zipForm.on('click', (e) => {
            // eslint-disable-line arrow-parens
            e.preventDefault();
            const zipVal = document.getElementById('zipForm').value;
            const currentPort = window.location.port;

            // Dynamic URL for dev, hotfix, local, etc.
            let currentUrl = `${window.location.protocol}//${window.location.hostname}`;

            // For Local Dev
            if (currentPort === ('1337' || '1338')) {
                currentUrl = `${currentUrl}:${currentPort}`;
            }

            if (!isNaN(zipVal) && zipVal.length >= 5) {
                window.location.href = `${currentUrl}/compare-providers?zip=${zipVal}`;
            } else {
                window.location.href =
                    'https://www.cabletv.com/best-tv-providers';
            }

            return false;
        });
    });
};

// Module startup
const init = () => {
    zipFunction();
};

export { init };
